import { DynamicField, DynamicSections, Facility, PaymentDetailType } from '@cargos/sprintpay-models';
import moment from 'moment';
import { Detail } from '../details';
import { UserPayments } from '../payment/payment';
import { UserProperties } from './user';

export class GeodisUser implements UserProperties, UserPayments {
    constructor(
        private apis: Record<string, string>,
        public dynamicFields: DynamicField[] = [],
        public dynamicSections: DynamicSections[] = []
    ) {
        const paymentURL = this.apis['payments'];

        this.dynamicSections = [
            {
                id: 1,
                label: 'Geodis Customer Reference',
                orderNumber: 0,
                company: { id: 57, name: 'Geodis' },
                emailDomain: null,
            },
            {
                id: 2,
                label: 'Payment Details',
                orderNumber: 1,
                company: { id: 57, name: 'Geodis' },
                emailDomain: null,
            },
            {
                id: 3,
                label: 'Customer Reference',
                orderNumber: 2,
                company: { id: 57, name: 'Geodis' },
                emailDomain: null,
            },
        ];
        this.dynamicFields = [
            {
                name: 'eiReferenceFileNumber',
                label: 'Is your VIN Edoc’d in Nextgen',
                section: 0,
                fieldType: 'radioButton',
                company: undefined,
                emailDomain: 'geodis.com',
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                options: [
                    {
                        value: 'true',
                        displayValue: 'Yes',
                    },
                    {
                        value: 'null',
                        displayValue: 'N/A - Airline Fee',
                    },
                ],
                validations: [
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'eiReferenceFileNumber',
                label: 'Is your VIN Edoc’d in Nextgen',
                section: 1,
                fieldType: 'radioButton',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                options: [
                    {
                        value: 'true',
                        displayValue: 'Yes',
                    },
                    {
                        value: 'null',
                        displayValue: 'N/A - Airline Fee',
                    },
                ],
                validations: [
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'customerRef',
                label: 'GEODIS Job/Shipment',
                section: 1,
                fieldType: 'input',
                company: undefined,
                emailDomain: 'geodis.com',
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                validations: [
                    {
                        id: 0,
                        name: 'pattern',
                        value: [/^[a-zA-Z0-9]{8,}$/],
                        message: 'Minimum of 8 characters are required.',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'maxlength',
                        value: '255',
                        message: 'Maximum length exceeded (255 characters maximum)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your GEODIS Job/Shipment.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'customerRef',
                label: 'GEODIS Job/Shipment',
                section: 2,
                fieldType: 'input',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                validations: [
                    {
                        id: 0,
                        name: 'pattern',
                        value: '/^[a-zA-Z0-9]{8,}$/',
                        message: 'Minimum of 8 characters are required.',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'maxlength',
                        value: '255',
                        message: 'Maximum length exceeded (255 characters maximum)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your GEODIS Job/Shipment.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'externalReferenceNum',
                label: 'GEODIS Local Client Name',
                section: 1,
                fieldType: 'input',
                company: undefined,
                emailDomain: 'geodis.com',
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                validations: [
                    {
                        id: 0,
                        name: 'maxlength',
                        value: '30',
                        message: 'Limit of 30 characters',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter GEODIS Local Client Name.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'externalReferenceNum',
                label: 'GEODIS Local Client Name',
                section: 2,
                fieldType: 'input',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                validations: [
                    {
                        id: 0,
                        name: 'maxlength',
                        value: '30',
                        message: 'Limit of 30 characters',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter GEODIS Local Client Name.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'locationId',
                label: 'Location',
                section: 0,
                fieldType: 'dropdown',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                apiProviderData: `${paymentURL}/customer/approval-flow/information`,
                validations: [
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ];
    }

    public getPaymentDetails = (payment: PaymentDetailType, facility: Facility, id: string): Detail[] => [
        {
            label: facility.externalLookup ? 'File Number' : 'Second facility reference #',
            value: payment.hawb ? payment.hawb : 'N/A',
            show: !facility.externalLookup && !id,
        },
        { label: 'Paid To', value: payment.paidTo ? payment.paidTo : 'N/A', show: true },
        {
            label: 'Cargo facility',
            value: facility.name ? facility.name : 'N/A',
            show: true,
        },
        {
            label: 'Amount',
            value: payment.amount ? '$' + payment.amount.toFixed(2) : 'N/A',
            show: true,
        },
    ];

    public getPaymentCustomerReference = (
        payment: PaymentDetailType,
        customerReferenceLabel: string = ''
    ): Detail[] => [
        {
            label: customerReferenceLabel
                ? customerReferenceLabel
                : (this.dynamicFields.find((field) => field.name === 'customerRef')?.label ?? ''),
            value: payment.customerReference ? payment.customerReference : 'N/A',
            show: true,
        },
        {
            label: 'GEODIS Local Client Name',
            value: payment.externalReferenceNum ? payment.externalReferenceNum : 'N/A',
            show: true,
        },
        {
            label: 'Requester Email Address',
            value: payment.notificationEmail ? payment.notificationEmail : 'N/A',
            show: true,
        },
        { label: 'Notes', value: payment.notes ? payment.notes : 'N/A', show: true },
    ];

    public getCustomerInformation = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Customer Name',
            value: payment.customer ? payment.customer.name : 'N/A',
            show: true,
        },
        {
            label: 'Notification email',
            value: payment?.notificationEmail ? payment?.notificationEmail : 'N/A',
            show: true,
        },
        {
            label: 'Created Date',
            value: payment?.createdDate ? moment(payment?.createdDate).format('MMM DD, YYYY') : 'N/A',
            show: true,
        },
    ];

    public getCompanyCustomerReference = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Payment Amount',
            value: payment?.externalData?.type ?? 'N/A',
            show: !!(payment?.externalLookup && payment.id),
        },
        {
            label: 'Type',
            value: payment?.paymentType ?? 'N/A',
            show: !!(payment?.externalLookup && payment.id),
        },
        { label: 'Location', value: payment?.location ?? 'N/A', show: true },
    ];
}
